import Component from '../inherited/Component'

class SideCart extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._scrollArea = this._elem.querySelector('[data-side-cart-items]')
    }

    async mount () {
        this._ctx.on('cart-item-added', async () => {
            this.showSideCart()
        })
        let params = new URLSearchParams(window.location.search)
        if (params.has('show-cart')) {
            this.showSideCart()
        }

        this._doEditorListeners()
    }

    showSideCart () {
        this._scrollArea = this._elem.querySelector('[data-side-cart-items]')
        this._elem.classList.add('shown')
        this._ctx.on('cart-item-added--refreshed', (state, data) => {
            this._scrollArea = this._elem.querySelector('[data-side-cart-items]')
            this._ctx.emit('ffc--scroll-lock-elem', null, this._scrollArea)
        })
        
    }

    _doEditorListeners () {
      document.addEventListener('shopify:section:select', e => {
        if (e.target.contains(this._elem)) {
          this._elem.classList.add('shown')
        }
      })

      document.addEventListener('shopify:section:deselect', e => {
        if (e.target.contains(this._elem)) {
          this._elem.classList.remove('shown')
        }
      })
    }
}

export default SideCart
